import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-178317d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "skillsContainer" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showMoreTxt" }, "Show More +", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillBox = _resolveComponent("SkillBox")!
  const _component_ContentBox = _resolveComponent("ContentBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "section",
      style: _normalizeStyle({
            paddingTop: (_ctx.title == 'SKILLS') ? (_ctx.screen === 'computer' ? '2vw' : '5vw') : (_ctx.screen === 'computer' ? '5vw' : '12vw'),
            paddingBottom: (_ctx.title == 'EDUCATION') ? (_ctx.screen === 'computer' ? '8vw' : '15vw') : '0'
        })
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(["title font-bold", _ctx.screen == 'computer' ? 'pb-4' : 'pb-1'])
      }, _toDisplayString(_ctx.title), 3),
      (_ctx.title == 'SKILLS')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInfo, (info) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_SkillBox, { info: info }, null, 8, ["info"])
                ]))
              }), 256))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInfo.slice(0, 6), (info) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_ContentBox, { info: info }, null, 8, ["info"])
                ]))
              }), 256))
            ]),
            (_ctx.allInfo.length > 6 && !_ctx.showMore)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "showMore",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowMore(true)))
                }, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.showMore)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "container",
                  style: _normalizeStyle([{"margin-top":"1.042vw"}, { paddingBottom: _ctx.screen === 'computer' ? '3vw' : '6vw' }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInfo.slice(6), (info) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createVNode(_component_ContentBox, { info: info }, null, 8, ["info"])
                    ]))
                  }), 256))
                ], 4))
              : _createCommentVNode("", true)
          ]))
    ], 4)
  ]))
}